module.exports = __webpack_public_path__ + "img/task.7635f492.svg";